import { CONFIG_KEY } from '../../../scripts/constants.js';
import getConfig from '../../../scripts/utils/config-utils.js';
import { isChinaHost } from '../../../scripts/utils/url-utils.js';

const CODE_SUCCESS = 200;

export default async function fetchData() {
  const edgeWorkerEccn = getConfig(CONFIG_KEY.EDGE_WORKER_ECCN_PATH);
  const domain = isChinaHost()
    ? (getConfig(CONFIG_KEY.EDGE_WORKER_DOMAIN_CN) ??
      getConfig(CONFIG_KEY.EDGE_WORKER_DOMAIN))
    : getConfig(CONFIG_KEY.EDGE_WORKER_DOMAIN);
  try {
    const response = await fetch(`${domain}${edgeWorkerEccn}`);

    if (response.status !== CODE_SUCCESS) {
      throw new Error(`Failed to fetch JSON data: ${response.status}`);
    }
    const data = await response.json();
    return JSON.parse(data.items[0].fields.matrixData);
  } catch (error) {
    throw new Error(`Failed to get eccn data: ${error.message}`);
  }
}
